import { THEME } from '../../../cms/layout/types';
import { DesktopNavBar } from './DesktopHeader';
import { MobileNavBar } from './MobileHeader';

const InternationalNavBar = ({
  theme = THEME.light,
}: {
  theme?: THEME;
}): JSX.Element => {
  return (
    <>
      <div className={`sm:hidden`} data-testid="clear-tech-navbar">
        <DesktopNavBar theme={theme} />
      </div>
      <div className={`hidden sm:block`}>
        <MobileNavBar theme={theme} />
      </div>
    </>
  );
};

export { InternationalNavBar };
